<span class="align-self-center" [innerHTML]="data.message" matSnackBarLabel></span>
<span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">{{ data.action }}</button>
    <button mat-icon-button (click)="snackBarRef.dismiss()"><mat-icon>close</mat-icon></button>
</span>